"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeasureNumberFormat = exports.CUSTOM_FORMAT_PRESET_LOCAL_IDENTIFIER = void 0;
var tslib_1 = require("tslib");
// (C) 2020 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var typings_1 = require("./typings");
var PresetsDropdown_1 = require("./presetsDropdown/PresetsDropdown");
var CustomFormatDialog_1 = require("./customFormatDialog/CustomFormatDialog");
exports.CUSTOM_FORMAT_PRESET_LOCAL_IDENTIFIER = "customFormat";
var WrappedMeasureNumberFormat = /** @class */ (function (_super) {
    tslib_1.__extends(WrappedMeasureNumberFormat, _super);
    function WrappedMeasureNumberFormat(props) {
        var _this = _super.call(this, props) || this;
        _this.findSelectedPreset = function () {
            return _this.props.presets.find(function (preset) { return preset.format === _this.props.selectedFormat; }) ||
                _this.getCustomFormatPreset();
        };
        _this.toggleDropdownOpened = function (e) {
            _this.toggleButtonEl = e.currentTarget;
            _this.setState(function (state) { return (tslib_1.__assign(tslib_1.__assign({}, state), { showDropdown: !state.showDropdown })); });
            _this.toggleCustomFormatDialog();
        };
        _this.closeDropdown = function () {
            _this.setState({ showDropdown: false });
        };
        _this.toggleCustomFormatDialog = function (open) {
            if (open === void 0) { open = false; }
            _this.setState({
                showCustomFormatDialog: open,
            });
        };
        _this.onCustomFormatDialogApply = function (format) {
            _this.toggleCustomFormatDialog(false);
            _this.setState({
                selectedPreset: _this.getCustomFormatPreset(),
            });
            _this.props.setFormat(format);
        };
        _this.onCustomFormatDialogCancel = function () {
            _this.toggleCustomFormatDialog(false);
        };
        _this.onSelect = function (selectedPreset) {
            var setFormat = _this.props.setFormat;
            _this.closeDropdown();
            if (_this.isCustomPreset(selectedPreset)) {
                _this.toggleCustomFormatDialog(true);
            }
            else {
                _this.setState(function (state) { return (tslib_1.__assign(tslib_1.__assign({}, state), { selectedPreset: selectedPreset })); });
                setFormat(selectedPreset.format);
            }
        };
        _this.isCustomPreset = function (_a) {
            var localIdentifier = _a.localIdentifier, type = _a.type;
            return localIdentifier === exports.CUSTOM_FORMAT_PRESET_LOCAL_IDENTIFIER && type === typings_1.PresetType.CUSTOM_FORMAT;
        };
        _this.getCustomFormatPreset = function () { return ({
            name: _this.props.intl.formatMessage({ id: "measureNumberFormat.custom.optionLabel" }),
            localIdentifier: exports.CUSTOM_FORMAT_PRESET_LOCAL_IDENTIFIER,
            format: null,
            previewNumber: null,
            type: typings_1.PresetType.CUSTOM_FORMAT,
        }); };
        _this.state = {
            selectedPreset: _this.findSelectedPreset(),
            showDropdown: false,
            showCustomFormatDialog: false,
        };
        return _this;
    }
    WrappedMeasureNumberFormat.prototype.render = function () {
        var _a = this.props, ToggleButton = _a.toggleButton, anchorElementSelector = _a.anchorElementSelector, presets = _a.presets, separators = _a.separators, selectedFormat = _a.selectedFormat, defaultCustomFormat = _a.defaultCustomFormat, presetsDropdownPositioning = _a.presetsDropdownPositioning, customFormatDialogPositioning = _a.customFormatDialogPositioning, documentationLink = _a.documentationLink, templates = _a.templates, intl = _a.intl;
        var _b = this.state, showDropdown = _b.showDropdown, showCustomFormatDialog = _b.showCustomFormatDialog, selectedPreset = _b.selectedPreset;
        var buttonText = intl.formatMessage({ id: "measureNumberFormat.buttonLabel" }, { selectedFormatPresetName: selectedPreset.name });
        var anchorEl = anchorElementSelector || this.toggleButtonEl;
        var customPreset = this.getCustomFormatPreset();
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(ToggleButton, { text: buttonText, isOpened: showDropdown || showCustomFormatDialog, toggleDropdown: this.toggleDropdownOpened, selectedPreset: selectedPreset }),
            showDropdown && (react_1.default.createElement(PresetsDropdown_1.PresetsDropdown, { presets: presets, customPreset: customPreset, separators: separators, selectedPreset: selectedPreset, onSelect: this.onSelect, onClose: this.closeDropdown, anchorEl: anchorEl, positioning: presetsDropdownPositioning, intl: intl })),
            showCustomFormatDialog && (react_1.default.createElement(CustomFormatDialog_1.CustomFormatDialog, { onApply: this.onCustomFormatDialogApply, onCancel: this.onCustomFormatDialogCancel, formatString: selectedFormat || defaultCustomFormat, separators: separators, anchorEl: anchorEl, positioning: customFormatDialogPositioning, documentationLink: documentationLink, templates: templates, intl: intl }))));
    };
    return WrappedMeasureNumberFormat;
}(react_1.default.PureComponent));
var MeasureNumberFormatWithIntl = react_intl_1.injectIntl(WrappedMeasureNumberFormat);
/**
 * @internal
 */
var MeasureNumberFormat = /** @class */ (function (_super) {
    tslib_1.__extends(MeasureNumberFormat, _super);
    function MeasureNumberFormat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MeasureNumberFormat.prototype.render = function () {
        return (react_1.default.createElement(sdk_ui_1.IntlWrapper, { locale: this.props.locale },
            react_1.default.createElement(MeasureNumberFormatWithIntl, tslib_1.__assign({}, this.props))));
    };
    return MeasureNumberFormat;
}(react_1.default.PureComponent));
exports.MeasureNumberFormat = MeasureNumberFormat;
//# sourceMappingURL=MeasureNumberFormat.js.map